//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.adapter

import blazern.lexisoup.graphql.model.ClientConfigQuery
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public object ClientConfigQuery_ResponseAdapter {
  public object Data : Adapter<ClientConfigQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("config")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): ClientConfigQuery.Data {
      var _config: ClientConfigQuery.Config? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _config = Config.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return ClientConfigQuery.Data(
        config = _config ?: missingField(reader, "config")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: ClientConfigQuery.Data,
    ) {
      writer.name("config")
      Config.obj().toJson(writer, customScalarAdapters, value.config)
    }
  }

  public object Config : Adapter<ClientConfigQuery.Config> {
    public val RESPONSE_NAMES: List<String> =
        listOf("backendRedirectionUrl", "minQueryLength", "maxQueryLength", "translateTextLengthMax", "translateTextLengthMin", "translateBatchSizeLimit")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): ClientConfigQuery.Config {
      var _backendRedirectionUrl: String? = null
      var _minQueryLength: Int? = null
      var _maxQueryLength: Int? = null
      var _translateTextLengthMax: Int? = null
      var _translateTextLengthMin: Int? = null
      var _translateBatchSizeLimit: Int? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _backendRedirectionUrl = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _minQueryLength = IntAdapter.fromJson(reader, customScalarAdapters)
          2 -> _maxQueryLength = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _translateTextLengthMax = IntAdapter.fromJson(reader, customScalarAdapters)
          4 -> _translateTextLengthMin = IntAdapter.fromJson(reader, customScalarAdapters)
          5 -> _translateBatchSizeLimit = IntAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return ClientConfigQuery.Config(
        backendRedirectionUrl = _backendRedirectionUrl,
        minQueryLength = _minQueryLength ?: missingField(reader, "minQueryLength"),
        maxQueryLength = _maxQueryLength ?: missingField(reader, "maxQueryLength"),
        translateTextLengthMax = _translateTextLengthMax ?: missingField(reader, "translateTextLengthMax"),
        translateTextLengthMin = _translateTextLengthMin ?: missingField(reader, "translateTextLengthMin"),
        translateBatchSizeLimit = _translateBatchSizeLimit ?: missingField(reader, "translateBatchSizeLimit")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: ClientConfigQuery.Config,
    ) {
      writer.name("backendRedirectionUrl")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.backendRedirectionUrl)

      writer.name("minQueryLength")
      IntAdapter.toJson(writer, customScalarAdapters, value.minQueryLength)

      writer.name("maxQueryLength")
      IntAdapter.toJson(writer, customScalarAdapters, value.maxQueryLength)

      writer.name("translateTextLengthMax")
      IntAdapter.toJson(writer, customScalarAdapters, value.translateTextLengthMax)

      writer.name("translateTextLengthMin")
      IntAdapter.toJson(writer, customScalarAdapters, value.translateTextLengthMin)

      writer.name("translateBatchSizeLimit")
      IntAdapter.toJson(writer, customScalarAdapters, value.translateBatchSizeLimit)
    }
  }
}
